<div class="row toolsContainer">
    <div class="col-lg-4 greenText" style="padding-right:0px; padding-left:0px; padding-top:5%">
        <h3 class="Caecilia76BoldItalic toolsHeader">
            Tools<br />For The Trade</h3>
        <div class="d-flex justify-content-end">
            <img style="width:10vw; margin-right:5%" src="{{this.baseImagePaths + 'dots.png'}}"
                alt="market dots image">
        </div>
    </div>
    <div class="col-lg-8">
        <div class="row toolsIconsOuter">
            <div class="col-lg-4 blueText text-center toolsIconsInner" style="cursor:pointer">
                <a href="/calculators?calcType=spreader">
                    <div class="toolsIconInnerAboveImage">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'soil-calc.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText toolsIconsText">
                            SPREADER
                            <br>
                            CALCULATOR
                        </h4>
                    </div>
                </a>
            </div>
            <div class="col-lg-4 blueText text-center toolsIconsInner" style="cursor:pointer">
                <a href="/calculators?calcType=conversion">
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'tissue-calc.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText toolsIconsText">
                            CONVERSION
                            <br>
                            CALCULATOR
                        </h4>
                    </div>
                </a>
            </div>
            <div class="col-lg-4 blueText text-center toolsIconsInner" style="cursor:pointer">
                <a href="/calculators?calcType=foliar">
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'foil-calc.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText toolsIconsText">
                            FOLIAR
                            <br>
                            CALCULATOR
                        </h4>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>